/* global $, _, Tracker, Modernizr */

$(document).ready(function () {
  'use strict'

  var $select2s = $('.select2')

  function init ($element) {
    var $this = $element

    var options = $this.data('select2-options') || {}

    if ($this.hasClass('select2_no-search')) {
      options = _.extend(
        {
          minimumResultsForSearch: -1
        },
        options
      )

      $this.select2(options)
    }
    else {
      $this.select2(options)
    }

    if ($this.data('tracking-event-category-on-change')) {
      $this.on('select2-selecting', function (event) {
        if (typeof window.Tracker !== 'undefined') {
          window.Tracker.pushEvent(
            {
              category: $this.data('tracking-event-category-on-change'),
              action: $this.data('tracking-event-action-on-change'),
              label: event.choice.text,
              value: $this.data('tracking-event-value-on-change'),
              noninteraction: $this.data('tracking-event-noninteraction-on-change')
            }
          )
        }
      })
    }

    if ($this.data('tracking-event-category-on-open')) {
      $this.on('select2-open', function () {
        if (typeof window.Tracker !== 'undefined') {
          window.Tracker.pushEvent(
            {
              category: $this.data('tracking-event-category-on-open'),
              action: $this.data('tracking-event-action-on-open'),
              label: $this.data('tracking-event-label-on-open'),
              value: $this.data('tracking-event-value-on-open'),
              noninteraction: $this.data('tracking-event-noninteraction-on-open')
            }
          )
        }
      })
    }
  }

  $select2s.each(function () {
    init($(this))
  })

  $(document).on('Select2::Init', function (event, $element) {
    init($element)
  })
})

$(document).ready(function () {
  'use strict'

  var LOCATION_SEARCH_QUERY_URL = '/geo/search/'
  var $root = $('.city-selector')

  function init ($element) {
    const isIntegerValue = !$element.hasClass('city-selector_text-value')
    var options = _.extend(
      {
        minimumInputLength: 3,
        id: function (city) {
          return Number(city.id)
        },
        ajax: {
          url: LOCATION_SEARCH_QUERY_URL,
          quietMillis: 200,
          dataType: 'json',
          data: function (term) {
            return {
              query: term,
              type: $element.data('city-selector-type') || '',
              from: $element.data('city-selector-from') || ''
            }
          },
          results: function (data) {
            return {results: data}
          }
        },
        initSelection: function (element, callback) {
          var city = {
            'id': isIntegerValue ? Number(element.val()) : element.val(),
            'value': element.data('location') || ''
          }

          callback(city)
        },
        formatResult: function (city) {
          return '<div class="select2-user-result">' + city.value + '</div>'
        },
        formatSelection: function (city) {
          return city.short || city.value
        },
        formatInputTooShort: function () {
          return 'Начните печатать'
        },
        dropdownCssClass: function () {
          return $element.data('dropdown-css-class') || ''
        }
      },
      $element.data('select2-options') || {}
    )

    $element.select2(options)
    if ($element.hasClass('select2-container_empty')) {
      $element.prev('.inputt').addClass('select2-container_empty')
      if (!Boolean($element.data('location'))) {
        $element.removeClass('select2-container_empty')
      }
    }

    var $clearResults = $element.next('.select2-container__remove')
    var $select2Container

    $clearResults.on('click', function () {
      if (!$(this).is('[href]')) {
        $select2Container = $element.prev('.select2-container')
        $element.select2('data', null)
        $select2Container.addClass('select2-container_empty')
        $select2Container.find('.select2-chosen').text('Все города, выберите свой')
      }
    })

    $element.on('select2-close', function () {
      _.defer(function () {
        $('.select2-container-active').removeClass('select2-container-active')
        $(':focus').blur()
      })
    })

    $element.on('select2-selecting', function (event) {
      if (typeof $select2Container === 'undefined') {
        $select2Container = $element.prev('.select2-container')
      }
      $select2Container.removeClass('select2-container_empty')

      if ($element.data('tracking-event-category-on-change')) {
        if (typeof window.Tracker !== 'undefined') {
          window.Tracker.pushEvent(
            {
              category: $element.data('tracking-event-category-on-change'),
              action: $element.data('tracking-event-action-on-change'),
              label: event.choice.short || event.choice.value,
              value: $element.data('tracking-event-value-on-change'),
              noninteraction: $element.data('tracking-event-noninteraction-on-change')
            }
          )
        }
      }
    })

    if ($element.data('tracking-event-category-on-open')) {
      $element.on('select2-open', function () {
        if (typeof window.Tracker !== 'undefined') {
          window.Tracker.pushEvent(
            {
              category: $element.data('tracking-event-category-on-open'),
              action: $element.data('tracking-event-action-on-open'),
              label: $element.data('tracking-event-label-on-open'),
              value: $element.data('tracking-event-value-on-open'),
              noninteraction: $element.data('tracking-event-noninteraction-on-open')
            }
          )
        }
      })
    }

    getMatchingCityObject($element)
    triggerObjectChangeAtForm($element)
  }

  function triggerObjectChangeAtForm ($element) {
    var $form = $element.parents('form')

    if (Boolean($form.length > 0)) {
      $element
        .off('change.CitySelector::Change')
        .on('change.CitySelector::Change', function () {
          $form.trigger('CitySelector::Change', [$element.select2('data')])
        })

      $element.next('.select2-container__remove')
        .off('click.CitySelector::Change')
        .on('click.CitySelector::Change', function () {
          $form.trigger('CitySelector::Change', [$element.select2('data')])
        })
    }
  }

  function getMatchingCityObject ($element) {
    var $dfd = $.Deferred()
    const isIntegerValue = !$element.hasClass('city-selector_text-value')

    if (Boolean($element.data('location')) && !_($element.val()).isFinite() && !$element.hasClass('select2-container_empty') && isIntegerValue) {
      $element.val('')

      var $request = $.getJSON(LOCATION_SEARCH_QUERY_URL + '?query=' + $element.data('location') + '&type=' + ($element.data('city-selector-type') || '') + '&from=' + ($element.data('city-selector-from') || ''))
        .success(function (data) {
          if (_(data).isArray() && data.length > 0) {
            var city = _(data).first()
            var options = $element.data('select2-options')
            var isTrigger
            if (_(options).isObject()) {
              isTrigger = options.fireChangeAtLoad || false
            }
            if (isTrigger) {
              $element.select2('data', city)
              $element.trigger('change')
            }
            $dfd.resolve(city, data, $request)
          }
          else {
            $element.next('.select2-container__remove').trigger('click')
          }
        })
    }
    else {
      $dfd.reject()
    }

    return $dfd
  }

  $(document).on('CitySelector::Init', function (event, $element) {
    init($element)
  })

  $(document).on('CitySelector::GetMatchingCityObject', function (event, $element) {
    getMatchingCityObject($element)
  })

  $root.each(function () {
    init($(this))
  })
})
